import { MdRefresh } from "react-icons/md";

type TransactionHistoryRefreshButtonProps = {
  onRefresh: () => void;
  isRefreshing?: boolean;
};

const TransactionHistoryRefreshButton = ({
  onRefresh,
  isRefreshing = false,
}: TransactionHistoryRefreshButtonProps) => (
  <button
    type="button"
    onClick={onRefresh}
    disabled={isRefreshing}
    aria-label="Refresh transactions"
    className="flex items-center gap-1 px-1.5 py-1 rounded-lg text-gray-500 dark:text-gray-400 hover:text-secondary_button hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors disabled:opacity-50"
  >
    <MdRefresh
      className={`text-[16px] shrink-0 ${isRefreshing ? "animate-spin" : ""}`}
    />
    <span className="text-[13px] font-medium">Refresh</span>
  </button>
);

export default TransactionHistoryRefreshButton;
